import React from 'react';

const TrainingProgIcon = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4927 28.75C17.4927 29.4375 16.9304 30 16.2432 30H1.24948C0.562266 30 0 29.4375 0 28.75C0 23.9125 3.91087 20 8.74636 20C13.5818 20 17.4927 23.9125 17.4927 28.75ZM13.7443 12.5C13.7443 9.7375 11.5077 7.5 8.74636 7.5C5.98501 7.5 3.74844 9.7375 3.74844 12.5C3.74844 15.2625 5.98501 17.5 8.74636 17.5C11.5077 17.5 13.7443 15.2625 13.7443 12.5ZM23.7401 0H11.2453C7.88421 0 5.16035 2.675 5.02291 6C6.12245 5.3625 7.38442 5 8.74636 5C12.1699 5 15.0437 7.3 15.9434 10.4375L18.7422 13.2375L23.2278 8.75H21.2411C20.5539 8.75 19.9917 8.1875 19.9917 7.5C19.9917 6.8125 20.5539 6.25 21.2411 6.25H24.9896C26.364 6.25 27.4885 7.375 27.4885 8.75V12.5C27.4885 13.1875 26.9263 13.75 26.2391 13.75C25.5519 13.75 24.9896 13.1875 24.9896 12.5V10.5125L20.504 15C19.5294 15.975 17.9425 15.975 16.9679 15L16.0683 14.1C16.0683 14.1 16.0683 14.1125 16.0683 14.125C15.681 15.8875 14.6689 17.4125 13.282 18.4625C15.2436 19.325 16.9055 20.7375 18.0925 22.5H23.7526C27.2012 22.5 30 19.7 30 16.25V6.25C30 2.8 27.2012 0 23.7526 0H23.7401Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default TrainingProgIcon;
